$('.js-form-duplication').on('click', function(){
	$('[data-rol="duplication"]').removeClass('hidden');
	$(this).hide();

	$('[data-rol="delete-form"]').each(function(index, value) {
		if($(this).hasClass('hidden')) {
			$(this).removeClass('hidden');
		} 
	})
})





jQuery.validator.setDefaults({
	errorElement: 'div',
	errorPlacement: function(error, element) {
	  error.addClass('error');
	  error.appendTo(element.closest('.form__row-control'));
	},
	highlight: function(element, errorClass, validClass) {
	  $(element).addClass(errorClass).removeClass(validClass);
	},
	unhighlight: function(element, errorClass, validClass) {
	  var $input = $(element);

	  if ($input.val() === '') {

	    $input.removeClass(validClass).removeClass(errorClass);
	  } else {
	    $input.removeClass(errorClass).addClass(validClass);
		}
	},
	errorClass: 'is-error',
	validClass: 'is-valid',
	ignore: '.ignore'
});

jQuery.validator.addMethod('cyrillic', function(value, element) {
    return this.optional(element) || /^[-а-яА-ЯёЁ ]+$/.test(value);
}, 'Введите русские символы');

$.extend($.validator.messages, {
    required: 'Пожалуйста, заполните поле',
    remote: 'Поле заполнено некорректно',
    email: 'Пожалуйста, введите корректный email',
    url: 'URL некорректен',
    date: 'Некорректная дата',
    dateISO: 'Введите корректную дату в формате ISO.',
    number: 'Введите число.',
    digits: 'Введите только цифры.',
    creditcard: 'Введите правильный номер карты.',
    equalTo: 'Введите такое же значение ещё раз.',
    extension: 'Выберите файл с правильным расширением.',
    maxlength: $.validator.format('Введите не больше {0} символов.'),
    minlength: $.validator.format('Введите не меньше {0} символов.'),
    rangelength: $.validator.format('Введите значение длиной от {0} до {1} символов.'),
    range: $.validator.format('Введите число от {0} до {1}.'),
    max: $.validator.format('Введите число, меньшее или равное {0}.'),
    min: $.validator.format('Введите число, большее или равное {0}.')
});

$('.js-form').each(function() {
	$(this).validate();
});

